import {UserAccessRightType} from "@app/services/sftp-api/sftp-api.service";

export enum FolderAccessRight {
  READ = 1,
  WRITE,
}

export enum UserFolders {
  INBOX = "Inbox",
  OUTBOX = "Outbox",
}

export interface UserAccessRight {
  [UserFolders.INBOX]: FolderAccessRight;
  [UserFolders.OUTBOX]: FolderAccessRight;
}

export interface UserAccessRights {
  [UserAccessRightType.DEFAULT]: UserAccessRight;
  [UserAccessRightType.READ_ONLY]: UserAccessRight;
  [UserAccessRightType.READ_WRITE]: UserAccessRight;
}

export const userAccessRights: UserAccessRights = {
  [UserAccessRightType.DEFAULT]: {
    [UserFolders.INBOX]: FolderAccessRight.READ,
    [UserFolders.OUTBOX]: FolderAccessRight.WRITE,
  },
  [UserAccessRightType.READ_ONLY]: {
    [UserFolders.INBOX]: FolderAccessRight.READ,
    [UserFolders.OUTBOX]: FolderAccessRight.READ,
  },
  [UserAccessRightType.READ_WRITE]: {
    [UserFolders.INBOX]: FolderAccessRight.WRITE,
    [UserFolders.OUTBOX]: FolderAccessRight.WRITE,
  },
};
